import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import * as Global from 'src/app/global';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  Global = Global;
  toogle: boolean = false;
  constructor(public authService: AuthService) {}

  ngOnInit(): void {}
  toogleMenu() {
    this.toogle = !this.toogle;
  }
}
